import React from 'react';
import { ProductionItem } from 'constants/interface';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
// import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { buildRegularProductDisplay } from 'helpers/order';

import {
  ActionButton,
} from './style';

interface TableRowActionProps {
  item: ProductionItem
}

const TableRowAction = ({
  item,
}: TableRowActionProps): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  // const { url } = useRouteMatch();

  const onDetailsClick = () => {
    // const currentCrumbs = breadcrumbNavigator.current();
    // breadcrumbNavigator.replace([{
    //   label: 'Pedidos',
    //   url: ROUTES.orders.root,
    // }, {
    //   label: `Pedido Nº ${item.orderItem.order.seq}`,
    //   url: `${ROUTES.orders.root}/${item.orderItem.order.id}`,
    // }, {
    //   label: `${buildRegularProductDisplay(item, {
    //     quantity: false,
    //     tray: false,
    //   })}`,
    //   url: `${ROUTES.orders.root}${ROUTES.orders.items.root}/${item.id}`,
    // }], currentCrumbs.length);
    breadcrumbNavigator.push({
      label: buildRegularProductDisplay(item, {
        quantity: false,
        tray: false,
      }),
      url: `${ROUTES.orders.root}${ROUTES.orders.items.root}/${item.id}`,
    });
  };

  return (
    <ActionButton
      onClick={() => {
        onDetailsClick();
      }}
    >
      Consultar
    </ActionButton>
  );
};

export default TableRowAction;
